import axios from '@/libs/api.request';

export const getImportTaskList = (data) => {
  return axios.request({
    url: '/admin/ImportOperation/GetImportTaskList',
    method: 'post',
    data,
  });
};

export const getImportTaskErrors = (data) => {
  return axios.request({
    url: '/admin/ImportOperation/GetImportTaskErrors',
    method: 'post',
    data,
  });
};

export const markImportTaskHandled = (data) => {
  return axios.request({
    url: '/admin/ImportOperation/MarkImportTaskHandled',
    method: 'post',
    data,
  });
};

/** 同一导入任务下重新上传修正后的 Excel（传 taskId + importfile；operationId 可选，用于校验） */
export const retryImportTaskWithFile = (data) => {
  return axios.request({
    url: '/admin/ImportOperation/RetryImportTaskWithFile',
    method: 'post',
    data,
  });
};
